var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2915",
    "data-name": "Groupe 2915",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.334,
    height: 18.319,
    viewBox: "0 0 18.334 18.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    d: "M9.167,0A9.136,9.136,0,1,1,5.6.72,9.138,9.138,0,0,1,9.167,0Z",
    fill: "#4cbb17"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_784",
    "data-name": "Trac\\xE9 784",
    transform: "translate(5.261 5.979)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.529.707,2.737,5.5.708,3.47",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.736925363540649 6.91127347946167 L 2.029482126235962 6.204329490661621 L 0.0008932211203500628 4.177184104919434 L 1.415517091751099 2.762905597686768 L 2.736614942550659 4.083226203918457 L 6.821202278137207 -3.459261051830254e-06 L 8.236142158508301 1.414566397666931 L 3.444215536117554 6.204309463500977 L 2.736925363540649 6.91127347946167 Z",
    stroke: "none",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.da893a5e5b36d54632344b96133295d2.svg";
export { ForwardRef as ReactComponent };